










import Vue, { VueConstructor } from "vue";
import ItemAdminLinks from "@/components/ItemAdminLinks.vue";
import { CONTENT_URL } from '@/constants';

export default (Vue as VueConstructor<
  Vue & {
    $refs: {
      text: InstanceType<typeof HTMLElement>,
    };
  }
>).extend({

    components: {
        ItemAdminLinks,
    },

    props: {
        item: {
            type: Object,
            default: null
        },
    },

    mounted() {
        this.hookLinks();
    },

    updated() {
        this.hookLinks();
    },

    methods: {
        hookLinks() {
            this.$nextTick(() => {
                // Code that will run only after the entire view has been re-rendered
                // We use this because non-Vue HTML is added to the document and we want 
                // some dynamic behaviour on that as well
                // (we gebruiken requestAnimationFrame zodat de browser echt zo ver is)
                requestAnimationFrame(() => {
                    const el: HTMLElement = this.$refs.text;
                    el.querySelectorAll('a').forEach( (a: HTMLAnchorElement) => {
                        a.addEventListener('click', (e: MouseEvent) => {
                            e.preventDefault();
                            const url: string|undefined = a.hasAttribute('href') ?
                                a.getAttribute('href') as string :
                                undefined;
                            if (url && url.startsWith('mailto:')) {
                                // Vue-router doesn't handle mailto links 
                                window.location.href = url;
                            } else {
                                this.$router.push({ path: url });
                            }
                        });
                    });
                });
            });
        },
    },

    computed: {
        html(): string {
            let desc = this.item.text;
            // Zet <link></link> om naar <a href></a>
            desc = desc.replace(/'''([^=]+)'''/g, "<b>$1</b>");
            desc = desc.replace(/''([^=]+)''/g, "<i>$1</i>");
            desc = desc.replace(/====([^=]+)====/g, "<h5>$1</h5>");
            desc = desc.replace(/===([^=]+)===/g, "<h4>$1</h4>");
            desc = desc.replace(/==([^=]+)==/g, "<h3>$1</h3>");
            desc = desc.replace(
                /\[\[Image:([^\]]+)\]\]/g,
                `<img src='${CONTENT_URL}/universe/$1' alt='subject' />`
            );
            desc = desc.replace(
                /\[\[_root\]\]/g,
                '<a href="/about">All about GWTP</a>'
            );

            desc = desc.replace(
                /\[\[([^\|]+)\|([^\]]+)\]\]/g,
                (match: string, p1: string, p2: string) => `<a href="/about/${encodeURI(p1)}">${p2}</a>`
            );
            desc = desc.replace(
                /\[\[([^\]]+)\]\]/g,
                (match: string, p1: string) => `<a href="/about/${encodeURI(p1)}">${p1}</a>`
            );

            desc = desc.replace(/^index.php\?/g, "items?");
            //desc = desc.replace(/^.*gwtp.net\/index.php\?/g, "/items?");
            desc = desc.replace(
                /(https?:\/\/(www.)?gwtp.net\/)?index.php\?/g,
                "/items?"
            );

            desc = desc.replace(/ -> /g, " → ");

            // Per-line processing
            const lines = desc.split(/\n/);
            let inList = false;
            let desc2 = "<p>";
            let previousLineWasEmpty = true;
            lines.forEach((line: string) => {
                // Bestaat regel alleen uit tags en whitespace?
                //let containsText = true;
                //if (line.match(/(\s+|<\/?[^>]+>)*/)) {
                //    containsText = false;
                //}

                if (line.trim().length === 0 && !previousLineWasEmpty) {
                    desc2 += "</p><p>";
                    previousLineWasEmpty = true;
                } else {
                    previousLineWasEmpty = false;
                }
                if (line.substr(0, 2) === "- ") {
                    if (!inList) {
                        desc2 += "<ul>";
                        inList = true;
                    }
                    desc2 += "<li>" + line.substr(2) + "</li>";
                } else {
                    if (inList) {
                        desc2 += "</ul>";
                        inList = false;
                    }
                    desc2 += line + "\n";
                }
            });
            if (inList) desc2 += "</ul>";

            return desc2 + "</p>";
        },
    },
});
